// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.document-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.document-search__input {
  --border-radius: 24px;
  --height: 48px;
  padding: 0;
}
.document-search__chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 4px;
}
.document-search__chips ion-chip {
  font-family: var(--font);
  font-size: 12px;
  height: 30px;
  cursor: pointer;
  transition: all 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-search/document-search.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,qBAAA;EACA,cAAA;EACA,UAAA;AACJ;AAEE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEI;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAAN","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.document-search {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &__input {\n    --border-radius: 24px;\n    --height: 48px;\n    padding: 0;\n  }\n\n  &__chips {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding: 0 4px;\n\n    ion-chip {\n      font-family: var(--font);\n      font-size: 12px;\n      height: 30px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
